import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// MUI
import { Box } from "@mui/material";

// Components
import Navbar from "./components/Navbar";
import HeroSlider from "./components/HeroSlider";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop"; // ✅ FIXED BUTTON

// Sections
import ClientsSlider from "./sections/ClientsSlider";
import About from "./sections/About";
import Products3D from "./sections/Products3D";
import Spares from "./sections/Spares";
import Capabilities from "./sections/Capabilities";
import Certification from "./sections/Certification";
import Services from "./sections/Services";
import Approval from "./sections/Approval";
import Careers from "./sections/Careers";
import Contact from "./sections/Contact";

// Pages
import ProductDetails from "./sections/ProductDetails";
import JobOpeningsPage from "./sections/JobOpeningsPage";

/* ===========================================================
   1️⃣ GLOBAL SCROLL TO TOP ON ROUTE CHANGE
=========================================================== */
function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

/* ===========================================================
   2️⃣ HOME PAGE WRAPPER (SECTION SCROLL SUPPORT)
=========================================================== */
function HomeWrapper() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        document
          .getElementById(location.state.scrollTo)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, [location]);

  return (
    <Box>
      <HeroSlider />
      <main>
        <ClientsSlider />
        <About />
        <Products3D />
        <Spares />
        <Capabilities />
        <Certification />
          <Approval />
        <Services />
       
        <Careers />
        <Contact />
      </main>
    </Box>
  );
}

/* ===========================================================
   3️⃣ MAIN APP COMPONENT
=========================================================== */
export default function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />

      <Navbar />

      <Routes>
        <Route path="/" element={<HomeWrapper />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/careers/job-openings" element={<JobOpeningsPage />} />
      </Routes>

      {/* ✅ FIXED RIGHT-SIDE SCROLL BUTTON */}
      <BackToTop />

      <Footer />
    </Router>
  );
}
